//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'earlySettleRetentionDialog',
    props: {
        value: Boolean,
        discountAmount: Number,
        themeType: String,
        isBtnDisabled: Boolean
    },
    data() {
        return {
            show: this.value,
        }
    },
    watch: {
        show() {
            this.$emit('input', this.show)
        },
        value() {
            this.show = this.value
        },
    },
    mounted() {
        this.sensorsRecord("h5_element_imp", {
            tgt_event_id: "h5_paycash_settle_retention_dialog",
            tgt_name: "h5-paycash-提前结清挽留弹窗",
            url: location.href,
            page: "还款-确认还款页",
            param4: this.discountAmount
        });
    },
    methods: {
        preRepay() {
            this.sensorsRecord("h5_clk", {
                tgt_event_id: "h5_paycash_early_settle",
                tgt_name: "h5-paycash-还款挽留-提前结清",
                url: location.href,
                page: "还款-确认还款页",
            });
            this.$emit("preRepay")
        },
        commonRepay() {
            this.sensorsRecord("h5_clk", {
                tgt_event_id: "h5_paycash_ontime_settle",
                tgt_name: "h5-paycash-还款挽留-按期还款",
                url: location.href,
                page: "还款-确认还款页",
            });
            this.$emit("commonRepay")
        }
    }
}
